/**
 * @generated SignedSource<<8d53d974a586e7f512f3af782ac65a22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditMainGeneral_room$data = {
  readonly name: {
    readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextField_text">;
  } | null;
  readonly " $fragmentType": "RoomEditMainGeneral_room";
};
export type RoomEditMainGeneral_room$key = {
  readonly " $data"?: RoomEditMainGeneral_room$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditMainGeneral_room">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomEditMainGeneral_room",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Text",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranslatableTextField_text"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Room",
  "abstractKey": null
};

(node as any).hash = "282800219992548ae91405820af8d6b0";

export default node;
